import _objectWithoutProperties from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _toConsumableArray from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _extends from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/extends";
import _classCallCheck from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _defineProperty from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import * as React from 'react';
import { View, Platform } from 'react-native';
import { polyfill } from 'react-lifecycles-compat';
import { TabView, PagerPan } from 'react-native-tab-view';
import createTabNavigator from '../utils/createTabNavigator';
import MaterialTopTabBar from '../views/MaterialTopTabBar';
import ResourceSavingScene from '../views/ResourceSavingScene';

var MaterialTabView =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(MaterialTabView, _React$PureComponent);

  function MaterialTabView() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, MaterialTabView);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(MaterialTabView)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      index: 0,
      isSwiping: false,
      loaded: [_this.props.navigation.state.index],
      transitioningFromIndex: null
    });

    _defineProperty(_assertThisInitialized(_this), "_renderIcon", function (_ref) {
      var focused = _ref.focused,
          route = _ref.route,
          tintColor = _ref.tintColor;
      var descriptors = _this.props.descriptors;
      var descriptor = descriptors[route.key];
      var options = descriptor.options;

      if (options.tabBarIcon) {
        return typeof options.tabBarIcon === 'function' ? options.tabBarIcon({
          tintColor: tintColor,
          focused: focused
        }) : options.tabBarIcon;
      }

      return null;
    });

    _defineProperty(_assertThisInitialized(_this), "_renderTabBar", function (props) {
      var state = _this.props.navigation.state;
      var route = state.routes[state.index];
      var descriptors = _this.props.descriptors;
      var descriptor = descriptors[route.key];
      var options = descriptor.options;
      var tabBarVisible = options.tabBarVisible == null ? true : options.tabBarVisible;
      var _this$props = _this.props,
          _this$props$tabBarCom = _this$props.tabBarComponent,
          TabBarComponent = _this$props$tabBarCom === void 0 ? MaterialTopTabBar : _this$props$tabBarCom,
          tabBarPosition = _this$props.tabBarPosition,
          tabBarOptions = _this$props.tabBarOptions;

      if (TabBarComponent === null || !tabBarVisible) {
        return null;
      }

      return (
        /* $FlowFixMe */
        React.createElement(TabBarComponent, _extends({}, tabBarOptions, props, {
          tabBarPosition: tabBarPosition,
          screenProps: _this.props.screenProps,
          navigation: _this.props.navigation,
          getLabelText: _this.props.getLabelText,
          getAccessibilityLabel: _this.props.getAccessibilityLabel,
          getTestID: _this.props.getTestID,
          renderIcon: _this._renderIcon,
          onTabPress: _this.props.onTabPress,
          onTabLongPress: _this.props.onTabLongPress
        }))
      );
    });

    _defineProperty(_assertThisInitialized(_this), "_renderPanPager", function (props) {
      return React.createElement(PagerPan, props);
    });

    _defineProperty(_assertThisInitialized(_this), "_handleAnimationEnd", function () {
      var lazy = _this.props.lazy;

      if (lazy) {
        _this.setState({
          transitioningFromIndex: null,
          isSwiping: false
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "_handleSwipeStart", function () {
      var _this$props2 = _this.props,
          navigation = _this$props2.navigation,
          lazy = _this$props2.lazy;

      if (lazy) {
        _this.setState({
          isSwiping: true,
          loaded: _toConsumableArray(new Set([].concat(_toConsumableArray(_this.state.loaded), [Math.max(navigation.state.index - 1, 0), Math.min(navigation.state.index + 1, navigation.state.routes.length - 1)])))
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "_handleIndexChange", function (index) {
      var _this$props3 = _this.props,
          animationEnabled = _this$props3.animationEnabled,
          navigation = _this$props3.navigation,
          onIndexChange = _this$props3.onIndexChange,
          lazy = _this$props3.lazy;

      if (lazy && animationEnabled) {
        _this.setState({
          transitioningFromIndex: navigation.state.index || 0
        });
      }

      onIndexChange(index);
    });

    _defineProperty(_assertThisInitialized(_this), "_mustBeVisible", function (_ref2) {
      var index = _ref2.index,
          focused = _ref2.focused;
      var _this$props4 = _this.props,
          animationEnabled = _this$props4.animationEnabled,
          navigation = _this$props4.navigation;
      var _this$state = _this.state,
          isSwiping = _this$state.isSwiping,
          transitioningFromIndex = _this$state.transitioningFromIndex;

      if (isSwiping) {
        var isSibling = navigation.state.index === index - 1 || navigation.state.index === index + 1;

        if (isSibling) {
          return true;
        }
      } // The previous tab should remain visible while transitioning


      if (animationEnabled && transitioningFromIndex === index) {
        return true;
      }

      return focused;
    });

    _defineProperty(_assertThisInitialized(_this), "_renderScene", function (_ref3) {
      var route = _ref3.route;
      var _this$props5 = _this.props,
          renderScene = _this$props5.renderScene,
          descriptors = _this$props5.descriptors,
          lazy = _this$props5.lazy,
          optimizationsEnabled = _this$props5.optimizationsEnabled;

      if (lazy) {
        var loaded = _this.state.loaded;
        var routes = _this.props.navigation.state.routes;
        var index = routes.findIndex(function (_ref4) {
          var key = _ref4.key;
          return key === route.key;
        });
        var navigation = descriptors[route.key].navigation;

        var mustBeVisible = _this._mustBeVisible({
          index: index,
          focused: navigation.isFocused()
        });

        if (!loaded.includes(index) && !mustBeVisible) {
          return React.createElement(View, null);
        }

        if (optimizationsEnabled) {
          return React.createElement(ResourceSavingScene, {
            isVisible: mustBeVisible
          }, renderScene({
            route: route
          }));
        }
      }

      return renderScene({
        route: route
      });
    });

    return _this;
  }

  _createClass(MaterialTabView, [{
    key: "render",
    value: function render() {
      var _this$props6 = this.props,
          navigation = _this$props6.navigation,
          animationEnabled = _this$props6.animationEnabled,
          renderScene = _this$props6.renderScene,
          onIndexChange = _this$props6.onIndexChange,
          rest = _objectWithoutProperties(_this$props6, ["navigation", "animationEnabled", "renderScene", "onIndexChange"]);

      var renderPager = rest.renderPager;
      var state = this.props.navigation.state;
      var route = state.routes[state.index];
      var descriptors = this.props.descriptors;
      var descriptor = descriptors[route.key];
      var options = descriptor.options;
      var swipeEnabled = options.swipeEnabled == null ? this.props.swipeEnabled : options.swipeEnabled;

      if (typeof swipeEnabled === 'function') {
        swipeEnabled = swipeEnabled(state);
      }

      if (animationEnabled === false && swipeEnabled === false) {
        renderPager = this._renderPanPager;
      }

      return React.createElement(TabView, _extends({}, rest, {
        navigationState: navigation.state,
        animationEnabled: animationEnabled,
        swipeEnabled: swipeEnabled,
        onAnimationEnd: this._handleAnimationEnd,
        onIndexChange: this._handleIndexChange,
        onSwipeStart: this._handleSwipeStart,
        renderPager: renderPager,
        renderTabBar: this._renderTabBar,
        renderScene:
        /* $FlowFixMe */
        this._renderScene
      }));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      var index = nextProps.navigation.state.index;

      if (prevState.index === index) {
        return null;
      }

      return {
        loaded: prevState.loaded.includes(index) ? prevState.loaded : [].concat(_toConsumableArray(prevState.loaded), [index]),
        index: index
      };
    }
  }]);

  return MaterialTabView;
}(React.PureComponent);

_defineProperty(MaterialTabView, "defaultProps", {
  // fix for https://github.com/react-native-community/react-native-tab-view/issues/312
  initialLayout: Platform.select({
    android: {
      width: 1,
      height: 0
    }
  }),
  animationEnabled: true,
  lazy: false,
  optimizationsEnabled: false
});

polyfill(MaterialTabView);
export default createTabNavigator(MaterialTabView);